import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import DeliveryArea from '../../models/DeliveryArea'

export interface DeliveryAreaListState extends PaginatedApiState {
  deliveryAreas?: DeliveryArea[]
}

const DeliveryAreaList = (state: DeliveryAreaListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<DeliveryAreaListState>('DELIVERY_AREA_LIST')(state, action)
  }
}

export default DeliveryAreaList
